import api from "@/lib/axios";

export const videoService = {
  // Get resumable upload URL
  async getResumableUploadUrl(filename, uploadedBy) {
    const response = await api.post('/get-resumeable-upload-url', {
      filename: filename,
      uploaded_by: uploadedBy
    });
    return response.data;
  },

  // Check video processing status
  async checkVideoStatus(filename) {
    const response = await api.post('/v1/video', {
      filename: filename
    });
    return response.data;
  },

  // Get video stream URL (for playing videos) - Now uses POST API
  async getVideoStreamUrl(filename) {
    try {
      const response = await api.post('/generateVideoURL', {
        filename: filename
      });
      return response.data.url || response.data;
    } catch (error) {
      console.error('Error generating video URL:', error);
      throw error;
    }
  },

  // Get audio stream URL (for playing audio) - Uses same endpoint as video
  async getAudioStreamUrl(filename) {
    try {
      const response = await api.post('/generateVideoURL', {
        filename: filename
      });
      return response.data.url || response.data;
    } catch (error) {
      console.error('Error generating audio URL:', error);
      throw error;
    }
  },

  // Get public video stream URL (for admin dashboard public videos) - Now uses POST API
  async getPublicVideoStreamUrl(publicUrl) {
    console.log('publicUrl', publicUrl);
    
    try {
      const response = await api.post('/generateVideoURL', {
        filename: publicUrl
      });
      return response.data.url || response.data;
    } catch (error) {
      console.error('Error generating public video URL:', error);
      throw error;
    }
  },

  // Get user audio for form (specific to user and their remote status)
  async getUserAudioUrl(userId) {
    try {
      const response = await api.get(`/v1/user-audio`);
      // The API should return audio URL for remote users
      if (response.data && response.data.data) {
        const audioData = response.data.data;
        // Return the audio filename/URL that can be used with generateVideoURL
        return audioData.audio_url || audioData.filename || audioData.public_url;
      }
      return null;
    } catch (error) {
      console.error('Error getting user audio URL:', error);
      throw error;
    }
  },

  // Update video status
  async updateVideoStatus(filename) {
    const response = await api.post('/v1/update-video-status', {
      filename: filename
    });
    return response.data;
  },

  // Assign video to user
  async assignUserToVideo(filename, userId) {
    const response = await api.post('/v1/assign-user-to-video', {
      filename: filename,
      user_id: userId
    });
    return response.data;
  },

  // Approve video assignment
  async approveVideo(filename) {
    const response = await api.post('/v1/approve-video', {
      filename: filename
    });
    return response.data;
  },

  // Get all assigned videos (for admin dashboard)
  async getAssignedVideos() {
    const response = await api.get('/v1/assigned-videos');
    return response.data;
  },

  // Get user videos (for user dashboard)
  async getUserVideos() {
    const response = await api.get('/v1/user-videos');
    console.log('User Videos API Response:', response.data);
    return response.data;
  }
}; 